import React from 'react';
import Card from '@mui/material/Card';

type Props = {};

const paraStyles = {
  color: 'white',
  fontSize: '1.1rem',
  textAlign: 'center',
  lineHeight: '25px',
  opacity: '0.6',
} as React.CSSProperties;

const imgStyles = {
  opacity: '0.8',
  width: '100px',
} as React.CSSProperties;

const NoPostsCard = (props: Props) => {
  const signboardImg = require('assets/signboard.svg');
  return (
    <Card
      sx={{
        width: '100%',
        backgroundColor: 'rgba(255,255,255,0.09803921568627451 )',
        boxShadow: 'unset',
        borderRadius: '20px',
        marginTop: '16px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        paddingBottom: '10px',
        height: '50vh',
      }}
    >
      <img style={imgStyles} src={signboardImg.default} alt="" />
      <p style={paraStyles}>
        Looks like you're not yet subscribed to anyone yet! <br /> Their feed
        will appear once you've chosen a creator to support.
      </p>
    </Card>
  );
};

export default NoPostsCard;
